export default __webpack_public_path__ + "static/606-539799b85897cca0e35e5143b30d5ce5.png";